/* NILO V5.13.72 — WhatsApp support, independent of COD/cart/checkout. */
(function () {
  'use strict';
  if (window.__niloWhatsAppHelpV51372) return;
  window.__niloWhatsAppHelpV51372 = true;
  function boot() {
    var root = document.querySelector('[data-nilo-wa-help]');
    if (!root) return;
    var raw = (root.getAttribute('data-wa-phone') || '').trim();
    // Morocco and international phone digits; no placeholder or old number fallback.
    var digits = raw.replace(/[^0-9]/g, '');
    if (/^0[567]\d{8}$/.test(digits)) digits = '212' + digits.slice(1);
    if (/^[567]\d{8}$/.test(digits)) digits = '212' + digits;
    if (!/^\d{10,15}$/.test(digits) || /^0/.test(digits)) return;
    var panel = root.querySelector('[data-nilo-wa-panel]');
    var toggle = root.querySelector('[data-nilo-wa-toggle]');
    var close = root.querySelector('[data-nilo-wa-close]');
    var link = root.querySelector('[data-nilo-wa-link]');
    if (!panel || !toggle || !close || !link) return;
    var arabic = /^ar(?:-|$)/i.test(root.dataset.waLocale || '');
    var title = String(root.dataset.waProductTitle || '').trim().slice(0,160);
    var context = root.dataset.waContext === 'cart' ? 'cart' : 'product';
    var url = String(root.dataset.waContextUrl || '').trim();
    try { var parsed = new URL(url, 'https://nilo.ma');
      if (!/^https:$/.test(parsed.protocol) || !/(^|\.)nilo\.ma$/.test(parsed.hostname) && parsed.origin !== location.origin) url = 'https://nilo.ma';
      else { parsed.search = ''; parsed.hash = ''; url = parsed.href; }
    } catch (_) { url = 'https://nilo.ma'; }
    var message;
    if (context === 'product') {
      message = arabic ? 'سلام، شفت هاد المنتوج فـ NILO' + (title ? ': ' + title : '') + '\n' + url + '\nبغيت نسولكم عليه قبل ما نطلبو.'
        : 'Salam, je voudrais un renseignement sur ce produit NILO' + (title ? ' : ' + title : '') + '\n' + url + '\nMerci !';
    } else {
      message = arabic ? 'سلام، عندي سؤال على الطلبية ديالي فـ NILO قبل ما نأكدها.\n' + url
        : 'Salam, j’ai une question sur mon panier NILO avant de commander.\n' + url;
    }
    link.href = 'https://wa.me/' + digits + '?text=' + encodeURIComponent(message);
    root.hidden = false;
    function setOpen(open, returnFocus) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) close.focus({preventScroll:true});
      else if (returnFocus) toggle.focus({preventScroll:true});
    }
    toggle.addEventListener('click', function () { setOpen(panel.hidden, false); });
    close.addEventListener('click', function () { setOpen(false, true); });
    document.addEventListener('click', function (ev) {
      if (!panel.hidden && !root.contains(ev.target)) setOpen(false, false);
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !panel.hidden) setOpen(false, true);
    });
    link.addEventListener('click', function () {
      // NILO Analytics only: no phone number, chat text or customer details logged.
      if (window.NiloAnalytics && typeof window.NiloAnalytics.track === 'function') {
        window.NiloAnalytics.track('whatsapp_click', {
          trigger: 'support_bubble', component: 'whatsapp_support', page_type: context
        });
      }
      setOpen(false, false);
    });
    function refreshSuppression() {
      var drawer = document.querySelector('[data-nilo-native-cod-drawer]');
      var quick = document.querySelector('.nilo-quick-add-drawer');
      var modalOpen = (drawer && !drawer.hidden) || (quick && !quick.hidden) || document.body.classList.contains('nilo-share-sheet-open');
      root.classList.toggle('nilo-wa-help--suppressed', !!modalOpen);
      if (modalOpen && !panel.hidden) setOpen(false, false);
    }
    refreshSuppression();
    if (window.MutationObserver) {
      // Only attributes that indicate modal opening; do not observe customer inputs.
      var obs = new MutationObserver(refreshSuppression);
      var drawer = document.querySelector('[data-nilo-native-cod-drawer]');
      if (drawer) obs.observe(drawer, {attributes:true,attributeFilter:['hidden','class','aria-hidden']});
      var quick = document.querySelector('.nilo-quick-add-drawer');
      if (quick) obs.observe(quick, {attributes:true,attributeFilter:['hidden','class','aria-hidden']});
      obs.observe(document.body,{attributes:true,attributeFilter:['class']});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();
